import React from 'react'
import { Link } from 'react-router-dom'
import Footer from '../components/Footer'

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-white">
      <header className="bg-white border-b border-line">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2 sm:gap-3 min-w-0">
              <img src="/logo.png" alt="MyWrenchLog" className="h-8 sm:h-10 w-auto flex-shrink-0" />
              <span className="text-lg sm:text-2xl font-bold text-ink">MyWrenchLog</span>
            </Link>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-ink mb-8">Privacy Policy</h1>
        <p className="text-sm text-gray-500 mb-8">Last updated: March 20, 2026</p>

        <div className="prose prose-gray max-w-none space-y-6 text-sm text-gray-700 leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-ink mt-8 mb-3">What We Collect</h2>
            <p>When you create an account, we collect your name and email address. When you use the app, we store the vehicle and maintenance data you enter, including vehicle details, service records, costs, and any files you upload.</p>
            <p>We do not collect analytics data, use tracking cookies, or share your data with third parties for advertising.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-ink mt-8 mb-3">How We Use Your Data</h2>
            <p>Your data is used solely to provide the MyWrenchLog service: storing your maintenance records, sending service reminders (if enabled), generating PDF reports, and processing payments through Stripe.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-ink mt-8 mb-3">Payment Processing</h2>
            <p>Payments are processed by <a href="https://stripe.com/privacy" className="text-accent hover:text-accent-dark" target="_blank" rel="noopener noreferrer">Stripe</a>. We do not store your credit card information. Stripe may collect information as described in their privacy policy.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-ink mt-8 mb-3">Email</h2>
            <p>We send transactional emails for account confirmation, password resets, and service reminders. We do not send marketing emails or newsletters.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-ink mt-8 mb-3">Data Storage</h2>
            <p>Your data is stored on servers in the United States using Amazon Web Services (AWS). Uploaded files are stored in Amazon S3.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-ink mt-8 mb-3">Data Deletion</h2>
            <p>You can delete your account at any time from your Account page. This permanently deletes all your data, including vehicles, maintenance records, uploaded files, and any active subscription.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-ink mt-8 mb-3">Cookies</h2>
            <p>MyWrenchLog does not use cookies for tracking or analytics. We use browser local storage to keep you logged in.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-ink mt-8 mb-3">Contact</h2>
            <p>If you have questions about this privacy policy or want to request your data, email <a href="mailto:support@mywrenchlog.com" className="text-accent hover:text-accent-dark">support@mywrenchlog.com</a>.</p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  )
}
